import React from 'react'
import Column from '@components/column'
import Typography from '@components/typography'
import {
  ApproveButton,
  RejectButton,
  StyleBankWrapper,
  StyledActionContainer,
} from '@commons/withdraw-request-modal/style'
import Svg from '@components/svg'
import { bankicon } from '@assets/icons'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import { Transaction } from '@apis'
import { useNavigate } from 'react-router-dom'
import { useModal } from '@context/ModalContext'
import { toast } from 'react-toastify'

const WithdrawRequestModal = ({ item, variant }) => {
  const { hideModal } = useModal()
  const initialValues = {
    requestAmount: item.amount,
    image: '',
  }
  const navigate = useNavigate()
  const handleSubmit = async (values, { resetForm }) => {
    if (!values.image) {
      toast.error('Receipt is required')
      return
    }
    try {
      const payload = {
        status: 'Approved',
        receipt:
          typeof values.image === 'string'
            ? values.image
            : {
                base64: values.image.base64,
                extension: values.image.extension,
              },
      }

      await Transaction.updateStatus({
        state: 'transaction',
        id: item.id,
        data: payload,
      }).then(() => {
        hideModal()
        navigate('/admin/transactions?tab=Withdrawal%20Released')
      })

      resetForm()
    } catch (err) {
      console.error(err)
    }
  }

  const handleReject = async () => {
    await Transaction.updateStatus({
      state: 'transaction',
      id: item.id,
      data: { status: 'Rejected' },
    }).then(() => {
      hideModal()
      navigate('/admin/transactions?tab=Withdrawal%20Rejected')
    })
  }

  return (
    <Column>
      <Typography color={'primary'} align={'center'} size={18}>
        Request Withdraw
      </Typography>

      <StyleBankWrapper>
        <Svg src={bankicon} />
        <Column stylecolumn={'gap:8px'}>
          <Typography size={16} color={'text100'}>
            Bank Name
          </Typography>
          <Typography size={14} color={'text200'}>
            Account Holder Name
          </Typography>
          <Typography size={14} color={'text200'}>
            Account Number
          </Typography>
        </Column>
      </StyleBankWrapper>

      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        <Form>
          <Column>
            <Fields.Input
              name="requestAmount"
              placeholder="Amount Here"
              label="Request Amount"
              disabled
            />
            {variant === 'accept' && (
              <Fields.Upload
                name="image"
                placeholder="Upload Receipt here"
                label="Upload Receipt"
              />
            )}
          </Column>

          <StyledActionContainer>
            {(variant === 'both' || variant === 'reject') && (
              <RejectButton
                title="Reject Request"
                type="button"
                onClick={handleReject}
              />
            )}
            {(variant === 'both' || variant === 'accept') && (
              <ApproveButton title="Approve Request" type="submit" />
            )}
          </StyledActionContainer>
        </Form>
      </Formik>
    </Column>
  )
}

export default WithdrawRequestModal
